const TRANSLATION_NAMESPACE = "error:channels."

export const FETCH_CHANNELS_DECLARATIONS_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}fetch-channels-declarations-failed`
export const FETCH_CHANNELS_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}fetch-channels-failed`
export const GET_WEBCHAT_CHANNEL_ADDITIONAL_DATA_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}get-webchat-channel-additional-data-failed`
